import React, { PureComponent } from "react";
import ReactDOM from "react-dom";

class MenuButton extends PureComponent {
	state = {
		isOpen: false
	};

	handleMenuClick = () => {
		const navContainer = document.querySelector("#nav__main");
		navContainer.classList.toggle("active-menu");
		this.setState(prevState => {
			return {
				isOpen: !prevState.isOpen
			};
		});
	};

	render() {
		const menuClass = this.state.isOpen ? "is-active" : null;
		return (
			<button
				type="button"
				className={`navbar-toggle hamburger hamburger--collapse ${menuClass}`}
				onClick={this.handleMenuClick}
			>
				<span className="hamburger-box">
					<span className="hamburger-inner"></span>
				</span>
			</button>
		);
	}
}

const menuDOM = document.getElementById("dom-react-menu-button");
ReactDOM.render(<MenuButton />, menuDOM);
